export enum INDEXDBTABLE {
    TABLEDAI = 'dai',
    TABLENOTELIST = 'note-list'
}

export const INDEXDBTABLES = [INDEXDBTABLE.TABLEDAI, INDEXDBTABLE.TABLENOTELIST]

export const table_Index = {
    'dai': 'daiblob_index',
    'note-list': 'notelist_index'
}

export const key_Path = {
    'dai': 'daicd',
    'note-list': 'groupId'
}